/* eslint-disable no-use-before-define */
import React from 'react'
import { publish, $, mediaQueries, bufferedFn } from '../../twd/twd.js'
import { Loader } from './tooltip/loader.js'

const showState = bufferedFn((el) => {
    if (!el) return
    publish('show_flyout', {
        el,
        showIcon: false,
        html: <Loader state={el.dataset.state} />,
        contentStyle:{maxWidth:'600px', width:'fit-content'},
        popperStyles:{
            maxWidth:`${Math.min(mediaQueries.width()-40, 600)}px`,
        }
    })
}, 100)

const hideState = bufferedFn((event) => {
    let ce = $(document.elementFromPoint(event.clientX, event.clientY))
    let b =  ce.data().tooltipId
        || ce.is('.flyout *')
    if (b) return

    publish('hide_flyout')
}, 200)

export const onMouseOverFn  = (event) => {
    let te = $(event.target)
    let id = te.data().tooltipId
    let el = $(`#${id}`)
    if (!el.length===0) return

    showState(el['0'])
}

export const onMouseOutFn = (event) => {

    let te = $(event.target)
    let id = te.data().tooltipId
    let el = $(`#${id}`)
    if (!el.length===0) return

    event.persist()
    hideState(event)
}



// WEBPACK FOOTER //
// ./src/municipals/map/tooltip.js